import { defineComponent as _defineComponent } from 'vue'
import { useValidator } from '@/core/app.service';
import { computed, onMounted, ref, watch } from 'vue';
import StockTransferOrderService from './stock-transfer-order.service';
import StockTransferOrderViewModel = Vertica.LouisPoulsen.Application.PointOfSale.StockTransferOrder.StockTransferOrderViewModel;
import StockTransferOrderLineViewObject = Vertica.LouisPoulsen.Application.PointOfSale.StockTransferOrder.StockTransferOrderLineViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'StockTransferOrderTable',
  props: {
    orderNumber: null,
    lineItems: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({(e: 'update', newOrderLines: StockTransferOrderViewModel)}), expose: any, slots: any, attrs: any }) {

const props = __props as { orderNumber: string, lineItems: StockTransferOrderLineViewObject[]}




const receivedQuantities = ref<{ [itemNumber: string]: string }>({});

function updateReceivedQuantities(newOrderLines: StockTransferOrderLineViewObject[]) {
    receivedQuantities.value = newOrderLines.reduce((result, lineItem) => {
        result[lineItem.purchasingDocumentItemNumber] = lineItem.receivedQuantity;
        return result;
    }, {});
}
onMounted(() => updateReceivedQuantities(props.lineItems));
watch(() => props.lineItems, updateReceivedQuantities, { deep: true });

const $validator = useValidator();
const disabledSubmit = computed<boolean>(() => $validator.errors.items.length > 0);
const submitting = ref<boolean>(false);

async function submitOrder() {
    submitting.value = true;
    try {
        const apiResponse = await StockTransferOrderService.update({
            orderNumber: props.orderNumber,
            lineItems: Object.keys(receivedQuantities.value).map<Vertica.LouisPoulsen.Application.PointOfSale.StockTransferOrder.StockTransferOrderUpdateLineItem>(
                itemNumber => ({
                    purchasingDocumentItemNumber: itemNumber,
                    receivedQuantity: parseInt(receivedQuantities.value[itemNumber], 10)
                }))
        });

        if (apiResponse.lineItems.length) {
            emit('update', apiResponse);
        }
        submitting.value = false;
    } catch {
        submitting.value = false;
    }
}


return { __sfc: true,props, emit, receivedQuantities, updateReceivedQuantities, $validator, disabledSubmit, submitting, submitOrder }
}

})